import React, { Component } from 'react';
import { Button, FormControl } from 'react-bootstrap';

interface VasRightProps {
    appendParams: Function
    searchParams: Object
}

type VasRightTypes = {
    VinNumber: string
    LicenseNumber: string
    LeaseNumber: string
    PurchasedFrom: string
    MaintenanceNum: string
}

class VasRight extends Component<VasRightProps, VasRightTypes> {

    constructor(props: any) {
        super(props)
        this.state = {
            VinNumber: "",
            LicenseNumber: "",
            LeaseNumber: "",
            PurchasedFrom: "",
            MaintenanceNum: ""
        }
    }

    componentDidMount() {
        let param: any = this.props.searchParams
        this.setState({ VinNumber: param.VinNumber, LicenseNumber: param.LicenseNumber, LeaseNumber: param.LeaseNumber, PurchasedFrom: param.PurchasedFrom })
    }

    handleChange = (event: { target: { name: any, value: any } }) => {
        this.setState({ [event.target.name]: event.target.value } as Pick<VasRightTypes, keyof VasRightTypes>)
        this.props.appendParams([{ [event.target.name]: event.target.value }])
    }


    clearForm = (propertyName: string) => {
        this.setState({ [propertyName]: "" } as Pick<VasRightTypes, keyof VasRightTypes>)
        this.props.appendParams([{ [propertyName]: "" }])
    }

    render() {
        return (
            <div className="VAS-RP">
                <div className="VAS-RP-Vin-Search-Field-Wrapper" >
                    <div className="VAS-RP-Vin-Search-Field-Input-Wrapper">
                        <FormControl
                            placeholder={"VIN #"}
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.VinNumber}
                            name="VinNumber"
                        />
                        {this.state.VinNumber.length > 0 && <Button id="vas-clear-param-btn-input" tabIndex={-1} onClick={() => this.clearForm("VinNumber")}>
                            <span id="vas-clear-x-btn" className="material-icons">
                                close
                            </span>
                        </Button>}
                    </div>
                </div>
                <div className="VAS-RP-License-Search-Field-Wrapper" >
                    <div className="VAS-RP-License-Search-Field-Input-Wrapper">
                        <FormControl
                            placeholder={"License #"}
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.LicenseNumber}
                            name="LicenseNumber"
                        />
                        {this.state.LicenseNumber.length > 0 && <Button id="vas-clear-param-btn-input" tabIndex={-1} onClick={() => this.clearForm("LicenseNumber")}>
                            <span id="vas-clear-x-btn" className="material-icons">
                                close
                            </span>
                        </Button>}
                    </div>
                </div>
                <div className="VAS-RP-Lease-Search-Field-Wrapper" >
                    <div className="VAS-RP-Lease-Search-Field-Input-Wrapper">
                        <FormControl
                            placeholder={"Lease #"}
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.LeaseNumber}
                            name="LeaseNumber"
                        />
                        {this.state.LeaseNumber.length > 0 && <Button id="vas-clear-param-btn-input" tabIndex={-1} onClick={() => this.clearForm("LeaseNumber")}>
                            <span id="vas-clear-x-btn" className="material-icons">
                                close
                            </span>
                        </Button>}
                    </div>
                </div>
                <div className="VAS-RP-Purchased-From-Search-Field-Wrapper" >
                    <div className="VAS-RP-Purchased-From-Search-Field-Input-Wrapper">
                        <FormControl
                            placeholder={"Purchased From"}
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.PurchasedFrom}
                            name="PurchasedFrom"
                        />
                        {this.state.PurchasedFrom.length > 0 && <Button id="vas-clear-param-btn-input" tabIndex={-1} onClick={() => this.clearForm("PurchasedFrom")}>
                            <span id="vas-clear-x-btn" className="material-icons">
                                close
                            </span>
                        </Button>}
                    </div>
                </div>
                <div className="VAS-RP-Maint-Search-Field-Wrapper" >
                    <div className="VAS-LP-Maint-Search-Field-Input-Wrapper">
                        <FormControl
                            placeholder={"Maintenance #"}
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.MaintenanceNum}
                            name="MaintenanceNum"
                        />
                        {this.state.MaintenanceNum.length > 0 && <Button id="vas-clear-param-btn-input" tabIndex={-1} onClick={() => this.clearForm("MaintenanceNum")}>
                            <span id="vas-clear-x-btn" className="material-icons">
                                close
                            </span>
                        </Button>}
                    </div>
                </div>
            </div>
        )
    }
}

export default VasRight